import { NgModule } from 'angular-ts-decorators';
import { moduleName } from '../constants';

import { HeroCustomizerV2ImageGalleryComponent } from './hero-customizer-v2.image-gallery.component';
import { HeroCustomizerV2ImageSliderComponent } from './hero-customizer-v2.image-slider.component';

import { OpenHeroCustomizerV2ImageGalleryDirective } from './open-hero-customizer-v2-image-gallery.directive';

@NgModule({
  declarations: [
    HeroCustomizerV2ImageGalleryComponent,
    HeroCustomizerV2ImageSliderComponent,

    OpenHeroCustomizerV2ImageGalleryDirective,
  ],
  id: `${moduleName}.image-gallery`,
  providers: [],
})
export class HeroCustomizerV2ImageGalleryModule {
}
